import {
	atLeast1Lowercase,
	atLeast1Number,
	atLeast1SpecialCharacter,
	atLeast1Uppercase,
	emailAddressRegex
} from './regexHelpers';

export const validateEmailRegex = value => {
	return emailAddressRegex.test(value.toLowerCase());
};

export const validateMinLength10 = value => {
	return value.length >= 10;
};

export const validateSixDigitCode = value => {
	return value.length === 6;
};

export const validatePasswordShape = value => {
	return (
		atLeast1Lowercase.test(value) &&
		atLeast1Uppercase.test(value) &&
		atLeast1Number.test(value) &&
		atLeast1SpecialCharacter.test(value) &&
		value.length >= 8
	);
};

export const validatePhoneNumber = input => {
	if (!input) return;
	const noSpecialCharacters = input.replaceAll(/[^\d A-Za-z]/g, '');
	if (noSpecialCharacters.startsWith('0')) {
		return false;
	}
	if (noSpecialCharacters.length > 15 || noSpecialCharacters.length === 1) {
		return false;
	}
	return true;
};
